import React from 'react'
import SegmentControl from 'src/views/Requests/views/Form/components/Steps/Services/components/SegmentControl'
import { Request } from 'src/types'

import { WrapCard } from '../../../../../styles'

import Form from './form'

type Props = {
  request: Request
}

function SearchCard({ request }: Props) {
  return (
    <WrapCard title={<SegmentControl />}>
      <Form request={request} />
    </WrapCard>
  )
}

export default SearchCard
